// extracted by mini-css-extract-plugin
export var input = "input-module--input--IOQ79";
export var error = "input-module--error--xWoAG";